import api from "../utils/api";
import { LOGOUT } from "./types";

export const search = ({
    page = 0,
    size = 25,
    order = "caption",
    direction = "ASC",
    search = "",
} = {}) => async (dispatch) => {
    try {
        const res = await api.get(
            `/v1/roles/p/${page}/s/${size}/o/${order}/${direction}/${encodeURIComponent(search)}`
        );
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};

export const one = ({ uuid }) => async (dispatch) => {
    try {
        const res = await api.get(`/v1/roles/i/${uuid}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};

export const save = ({ uuid, name, caption, meta }) => async (dispatch) => {
    try {
        const res = await api.post(`/v1/roles`, { uuid, name, caption, meta });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        throw err;
    }
};